import {gql} from "graphql.macro";

export const sendSupportMessage = gql`
    mutation sendSupportMessage($data:SupportMessageInput!, $wid: String!){
        sendSupportMessage(data: $data, workspaceId: $wid){
            isSent
        }
    }
`